export const MARK_NOTIFICATION_AS_READ = "MARK_NOTIFICATION_AS_READ",
  LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS",
  LOAD_NOTIFICATIONS_SUCCESS = "LOAD_NOTIFICATIONS_SUCCESS",
  LOAD_NOTIFICATIONS_ERROR = "LOAD_NOTIFICATIONS_ERROR",
  NEW_NOTIFICATION = "NEW_NOTIFICATION",
  LOAD_MORE_NOTIFICATIONS = "LOAD_MORE_NOTIFICATIONS",
  LOAD_MORE_NOTIFICATIONS_SUCCESS = "LOAD_MORE_NOTIFICATIONS_SUCCESS",
  LOAD_MORE_NOTIFICATIONS_ERROR = "LOAD_MORE_NOTIFICATIONS_ERROR",
  REMOTE_MARK_NOTIFICATION_AS_READ = "REMOTE_MARK_NOTIFICATION_AS_READ";
